import { Icon } from './Icon';
import { useTheme } from './ThemeRoot';
import { Tooltip } from './Tooltip';

/**
 * Per-surface day/night flip (design-language §9). Quiet hairline control; sun in night-mode
 * (tap → day), moon in day-mode (tap → night). Theme-aware, keyboard + tooltip accessible.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const toDay = theme === 'night';
  return (
    <Tooltip label={toDay ? 'Switch to day' : 'Switch to night'} side="bottom">
      <button
        type="button"
        onClick={toggle}
        aria-label={toDay ? 'Switch to day theme' : 'Switch to night theme'}
        className={`inline-grid h-9 w-9 place-items-center rounded-full border border-line text-subtle transition-colors duration-1 ease-physical hover:border-line-strong hover:text-brass ${className ?? ''}`}
      >
        <Icon name={toDay ? 'sun' : 'moon'} size={18} />
      </button>
    </Tooltip>
  );
}
